const PIXEL_ART_MAX_SIZE = 100;
export default PIXEL_ART_MAX_SIZE;
